export const LIST_ADMIN_LOCATIONS = 'LIST_ADMIN_LOCATIONS';
export const GET_ADMIN_LOCATION = 'GET_ADMIN_LOCATION';
export const UPDATE_ADMIN_LOCATION_SETTINGS = 'UPDATE_ADMIN_LOCATION_SETTINGS';
export const CREATE_ADMIN_LOCATION = 'CREATE_ADMIN_LOCATION';